<template>
	<div v-if="isUserAllowedInLevel5or6" class="justify-between flex" style="flex-direction: column">
		<div>
			<div class="wrapper flex bg-white rounded-t border-b-2 border-solid shadow-md px-8" :class="getSubtitle == null ? 'h-16' : 'h-20'">
				<div class="flex flex-col justify-center pt-4 pb-4">
					<div class="flex flex-grow flex-row w-full">
						<h1 class="text-lg md:text-xl lg:text-2xl font-bold">
							{{ title }}
						</h1>
					</div>

					<div class="flex flex-grow flex-row w-full">
						{{ getSubtitle }}
					</div>
				</div>
			</div>
			<div class="main h-full" style="height: 100%;" v-if="!isLoading">
				<div
					v-if="textTemplate.blade_name === 'payment_order_comprehensive' || textTemplate.blade_name === 'payment_order_liability'"
					class="space-x-4 w-1/2 mb-4 flex"
				>
					<BaseRadioForm
						ref="BaseRadioForm"
						:options="dropDownOptions"
						v-model="selectedItem"
						:label="$t('assignment')"
						:allow-empty="false"
						:required="true"
						class="w-96 flex-shrink-0"
					/>
					<div class="flex rounded-full h-6 w-6 justify-center cursor-pointer tooltip" style="background-color: lightgrey; align-items: center">
						<font-awesome-icon :icon="['fas', 'info']" class="flex justify-center text-connectProBlue" style="align-content: center" />
						<div class="tooltiptext mt-10" style="min-width: 350px;">
							<strong>Sicherungshalber</strong> {{ $t('assignment_explanation') }} <strong>Erfüllungshalber</strong>
							{{ $t('assignment_explanation_2') }}
						</div>
					</div>
				</div>

				<div class="mt-0 pt-0">
					<BaseTextarea
						ref="start_template"
						v-model="textTemplate.values[0].variable_value"
						label="Text"
						required="true"
						maxlength="1500"
						text-area-class="h-56"
						@focus="focusTextarea('start_template')"
					/>
				</div>
			</div>
		</div>

		<Footer class="mx-8 justify-center" :is-back-button="true" @backButtonClick="$router.go(-1)">
			<template #continueButton>
				<SaveButton @click="save" class="w-16 btn-blue">
					{{ $t('general.save') }}
				</SaveButton>
			</template>
		</Footer>
	</div>
	<Forbidden v-else />
</template>

<script>
import RouteWatcher from '@/mixins/RouteWatcher';
import { PdfTemplatesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseHeader from '@/components/navigation/BaseHeader';
import BaseTextarea from '@/components/forms/inputs/BaseTextarea';
import Validate from '@/mixins/Validate';
import Footer from '@/components/damagecases/Footer.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';
import BaseRadioForm from '@/components/forms/inputs/BaseRadioForm.vue';

export default {
	name: 'FormEdit',
	components: { BaseRadioForm, Forbidden, SaveButton, BaseTextarea, BaseHeader, Footer },
	mixins: [RouteWatcher, Validate, Authentication],
	data() {
		return {
			textTemplate: {},
			title: 'Formular',
			activeTextareaRefKey: null,
			isLoading: true,
			dropDownOptions: [
				{ display: this.$t('precaution'), value: 'precaution' },
				{ display: this.$t('performance'), value: 'performance' },
			],
			selectedItem: null,
		};
	},
	computed: {
		getSubtitle() {
			return this.textTemplate.blade_name === 'payment_order_comprehensive' || this.textTemplate.blade_name === 'payment_order_liability'
				? this.$t('assignment_subtitle')
				: null;
		},
	},
	methods: {
		focusTextarea(refKey) {
			this.activeTextareaRefKey = refKey;
		},
		changeText() {
			if (this.selectedItem.value === 'precaution') {
				if (this.textTemplate.blade_name === 'payment_order_comprehensive') {
					this.textTemplate.values[0].variable_value = this.$t('comprehensive_precaution');
				} else {
					this.textTemplate.values[0].variable_value = this.$t('liability_precaution');
				}
			} else if (this.selectedItem.value === 'performance') {
				if (this.textTemplate.blade_name === 'payment_order_comprehensive') {
					this.textTemplate.values[0].variable_value = this.$t('comprehensive_performance');
				} else {
					this.textTemplate.values[0].variable_value = this.$t('liability_performance');
				}
			}
		},
		save() {
			if (this.validate()) {
				if (this.textTemplate.blade_name === 'payment_order_comprehensive' || this.textTemplate.blade_name === 'payment_order_liability') {
					this.textTemplate.template_type = this.selectedItem;
				}
				PdfTemplatesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.pdfTemplatesIdPut(this.$route.params.id, this.textTemplate)
					.then(response => {
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('form_saved').toString(), 'success').then(_ => {
							this.$router.push({ name: 'forms' });
						});
					})
					.catch(error => {
						this.$swal(this.$t('general.error').toString(), this.$t('form_save_error').toString(), 'error');
					});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
		onRouteChange() {
			if (this.isUserAllowedInLevel5or6) {
				this.isLoading = true;
				// this.selectedItem = this.dropDownOptions[0];
				this.requestTextTemplate();
			}
		},
		requestTextTemplate() {
			PdfTemplatesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.pdfTemplatesIdGet(this.$route.params.id)
				.then(response => {
					const data = response.data.data;
					this.textTemplate = data;
					this.title = data.pretty_name;
					this.dropDownOptions.forEach(element => {
						if (response.data.data.template_type === element.value) {
							this.selectedItem = element.value;
						}
					});
					this.isLoading = false;
				});
		},
	},
};
</script>

<style lang="sass" scoped>
.wrapper
  border-color: $sp_blue
</style>
